<template>
<div class="m-lgSelects" @click.prevent="toggle">
  <p>{{current.name}}<i class="caret" :class="{'caret-reverse': isOpen}"></i></p>
  <ul v-if="isOpen">
    <li v-for="item in selects" @click="onSelect(item)" :key="item.value" :class="{'z-active': item.value === current.value}">{{item.name}}</li>
  </ul>
</div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'LgSelects',
  data() {
    return {
      isOpen: !1,
      current: {},
    };
  },
  props: {
    value: {
      required: !0,
    },
    selects: {
      required: !0,
      type: Array,
    },
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    },
    onSelect(item) {
      this.current = item;
      this.$emit('input', item.value);
    },
  },
  components: {

  },
  mixins: [],
  created() {
    this.current = _.find(this.selects, { value: this.value }) || this.selects[0];
  },
  mounted() {

  },
};
</script>

<style lang="less">
@import "selects";
</style>



// WEBPACK FOOTER //
// src/components/login_forms/selects.vue